import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import DeeplinkQuestion from '@/pages/deeplink-question'

export const Route = createFileRoute('/app/deeplink-question/$questionId')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { questionId } = Route.useParams()
  return <DeeplinkQuestion questionId={Number(questionId)} />
}
